import React from "react";
import cx from "classnames";
import ButtonCopy from "../ButtonCopy/ButtonCopy";
import s from "./parametersTable.scss";
import { Icon, check, attention } from "Icons/index";

export default function ParametersTable({ params, label, className, status, warningComponent }) {
  return (
    <div
      className={cx(className, {
        [s[status]]: true,
      })}
    >
      {label && <div className={s.tableLabel}>{label}</div>}

      {warningComponent && <div className="mt-3">{warningComponent}</div>}

      <div className={s.table}>
        {params.map((p, i) => (
          <div key={p.label}>
            <div className={cx(s.itemLabel, { [s.borderTop]: i > 0 })}>{p.label}</div>
            <div className={s.itemValue}>
              {p.value}

              <div className={s.itemValueActions}>
                <ButtonCopy value={p.value} className={cx(s.buttonCopy, { [s.hidden]: !p.copy })} />
                {status === "valid" && <Icon className={s.iconCheck} svg={check} width="1rem" height="1rem" />}
                {status === "error" && <Icon className={s.iconClose} svg={attention} width="1rem" height="1rem" />}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
